/*
 * Copyright (c) GET-Surface-UI 2020. This library belongs to GET AG and the license provided and permitted by GET AG. Stricly prohibited any commercial and personal use. Any kind of illegal work will be sued by GET AG and will be punished by the local and international law
 */
import { __assign, __decorate, __extends } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
var Widget = /** @class */ (function (_super) {
    __extends(Widget, _super);
    function Widget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Widget.prototype, "defaultLabels", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "widgetLabels", {
        get: function () {
            return __assign(__assign({}, this.defaultLabels), this.labels);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "defaultData", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "widgetData", {
        get: function () {
            return __assign(__assign({}, this.defaultData), this.data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "defaultCtx", {
        get: function () {
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Widget.prototype, "widgetCtx", {
        get: function () {
            return __assign(__assign({}, this.defaultCtx), this.context);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Object, default: function () { return ({}); } })
    ], Widget.prototype, "labels", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({}); } })
    ], Widget.prototype, "data", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({}); } })
    ], Widget.prototype, "context", void 0);
    Widget = __decorate([
        Component
    ], Widget);
    return Widget;
}(Vue));
export default Widget;
